<div class="app-list-table">
  <div class="app-list-header"
       *ngIf="!hideHeader"
       fxLayout="row"
       fxLayoutAlign="start center"
       fxLayoutGap="8px"
       fxLayoutGap.gt-xs="24px">
    <div class="app-list-name">{{ name }}</div>
    <div *ngIf="form" class="app-list-name">
      <form [formGroup]="form">
        <div fxLayout="row" fxLayoutAlign="start center" fxFlex>

          <mat-form-field fxFlex class="system-form-field">
            <mat-label>Código DEX</mat-label>
            <input type="text" formControlName="dexCode" matInput required>
          </mat-form-field>
          <mat-form-field fxFlex class="system-form-field">
            <mat-label>Cliente</mat-label>
            <input type="text" formControlName="clientCode" matInput required>
          </mat-form-field>

        </div>
      </form>
    </div>

    <button type="button" mat-raised-button color="primary" (click)="sendDownloadButton()" [disabled]="!form?.valid">
      Descargar
    </button>

    <ng-content></ng-content>
  </div>